import styles from '~/styles/atoms/row/row.module.scss'

import { ChildProps, ClickProps } from '~/common/define/props'
import React from 'react'
import SwitchLink from '~/components/atoms/link/SwitchLink'

interface Props extends ChildProps {
  onClick?(e: React.MouseEvent<HTMLElement>): void
  link?: string
  external?: boolean
}

const RowLink = ({children, onClick, link, external}: Props) => {
  return (
    <SwitchLink className={styles.row__link} onClick={onClick} link={link} external={external}>
      {children}
    </SwitchLink>
  )
}

export default RowLink